
export function ReadAsMaster(action, self, ReadMasterSuccess, ReadMasterFailed) {
  return {
    data : {
      AuthorizationToken : self.props.UserReducer.token,
    },
    action : action,
    self: self,
    onsuccess : ReadMasterSuccess,
    onfailed : ReadMasterFailed,
   }
}

export function ReadPropsMyAsset(self, onReadSuccess, onReadFailed, summaryTab, order, filter, page) {
  return {
    data : {
      AuthorizationToken : self.props.UserReducer.token,
    },
    self       : self,
    // RunRedux   : self.props.RunRedux,
    onsuccess  : self.onReadSuccess,
    onfailed   : self.onReadFailed,
    summaryTab : summaryTab,
    filter     : filter,
    order      : order,
    page       : page,
   }
}

export function ReadPropsMyAssetSummary(action, self, onReadSuccess, onReadFailed) {
  return {
    data : {
      AuthorizationToken : self.props.UserReducer.token,
    },
    action : action,
    self: self,
    RunRedux : self.props.RunRedux,
    onsuccess : onReadSuccess,
    onfailed : onReadFailed,
   }
}

export function ReadPropsAllAsset(action, self, onReadSuccess, onReadFailed, alias) {
  return {
    data : {
      AuthorizationToken : self.props.UserReducer.token,
      Alias : alias
    },
    action : action,
    self: self,
    // RunRedux : self.props.RunRedux,
    onsuccess : onReadSuccess,
    onfailed : onReadFailed,
   }
}

export function ReadPropsBookedAsset(action, self, onReadSuccess, onReadFailed, filter, order, page, alias='') {
  return {
    data : {
      AuthorizationToken : self.props.UserReducer.token,
      filter : filter,
      order  : order,
      page   : page,
    },
    action    : action,
    self      : self,
    alias     : alias,
    RunRedux  : self.props.RunRedux,
    onsuccess : onReadSuccess,
    onfailed  : onReadFailed,
   }
}

export function ReadPropsIncomingMessage(action, self, onReadSuccess, onReadFailed) {
  return {
    data : {
      AuthorizationToken : self.props.UserReducer.token,
    },
    action    : action,
    self      : self,
    // Reducer: self.props.Reducer,
    RunRedux  : self.props.RunRedux,
    onsuccess : onReadSuccess,
    onfailed  : onReadFailed,
   }
}

export function ReadPropsMasterReservation(action, self, ReadMasterSuccess, ReadMasterFailed, alias) {
  return {
      data : {   
          query: alias,
          AuthorizationToken : self.props.UserReducer.token,
      },
      self : self,
      action : action,
      onsuccess : ReadMasterSuccess,
      onfailed : ReadMasterFailed,
  }
}

export function ReadPropsReservationCheck(action, self, ReadSuccess, ReadFailed, data) {
    return {
        data : {   
            Alias               : data.Alias,
            AuthorizationToken  : self.props.UserReducer.token,
            Data                : data
        },
        self : self,
        action : action,
        onsuccess : ReadSuccess,
        onfailed : ReadFailed,
   }
}

export function ReadPropsQRReassign(action, self, ReadSuccess, ReadFailed, alias) {
  return {
      data : {   
          Alias               : alias,
          AuthorizationToken  : self.props.UserReducer.token,
      },
      self : self,
      action : action,
      onsuccess : ReadSuccess,
      onfailed : ReadFailed,
  }
}

// REGISTER
export function RegisterPropsReasign(self, OnRegisterSuccsess, OnRegisterFailed) {
  return {
    data : {
      Asset    : self.state.AssetAlias,
      Message  : '',
      ToUser   : self.state.ToUser,
      AuthorizationToken : self.props.UserReducer.token,
    },    
    self: self,
    onsuccess: OnRegisterSuccsess,
    onfailed : OnRegisterFailed,
   }
}

export function BulkRegisterPropsReasign(self, alias, OnRegisterSuccsess, OnRegisterFailed) {
  return {
    data : {
      Asset    : alias,
      Message  : '',
      ToUser   : self.state.ToUser,
      AuthorizationToken : self.props.UserReducer.token,
    },    
    self: self,
    onsuccess: OnRegisterSuccsess,
    onfailed : OnRegisterFailed,
   }
}

export function RegisterPropsRequestMaintenance(self, onsuccess, onfailed) {
    return {
    data : {
      field: {
        Asset       : self.state.Asset,
        Service     : self.state.Service,
        Description : self.state.Description,
      },
      AuthorizationToken : self.props.UserReducer.token,
    },    
    self: self,
    onsuccess: self.onRequestSuccess,
    onfailed : self.onRequestSuccess,
   }
}

export function RegisterConfirmationAnswer(action, self, OnRegisterConfirmationAnswerSuccsess, OnRegisterConfirmationAnswerFailed) {
  return {
    data : {
      Answer            : self.RequestParams.Answer,
      DueDate           : self.RequestParams.DueDateToUTCtime,
      Message           : self.RequestParams.ActiveDataModal.message,
      StartDate         : self.RequestParams.StartDate,
      MyReservation     : self.RequestParams.MyReservation,
      Site              : self.RequestParams.Site,
      Location          : self.RequestParams.Location,
      ConfirmationAlias : self.RequestParams.ActiveDataModal.Alias,
      AuthorizationToken: self.props.UserReducer.token,
    },    

    self: self,
    action: action,
    onsuccess: OnRegisterConfirmationAnswerSuccsess,
    onfailed : OnRegisterConfirmationAnswerFailed,
   }
}

export function RegisterQRConfirmationAnswer(action, self, OnRegisterConfirmationAnswerSuccsess, OnRegisterConfirmationAnswerFailed) {
  return {
    data : {
      DueDate           : self.RequestParams.DueDateToUTCtime,
      Message           : self.RequestParams.Message,
      StartDate         : self.RequestParams.StartDate,
      MyReservation     : self.RequestParams.MyReservation,
      Site              : self.RequestParams.Site,
      Location          : self.RequestParams.Location,
      Alias             : self.RequestParams.ActiveDataModal.Alias,
      // ConfirmationAlias : self.RequestParams.ActiveDataModal.Alias,
      AuthorizationToken: self.props.UserReducer.token,
    },    

    self: self,
    action: action,
    onsuccess: OnRegisterConfirmationAnswerSuccsess,
    onfailed : OnRegisterConfirmationAnswerFailed,
   }
}

export function RegisterPropsQRReassign(action, self, ReadSuccess, ReadFailed, assetAlias) {
  return {
      data : {   
          Asset               : assetAlias,
          AuthorizationToken  : self.props.UserReducer.token,
      },
      self : self,
      action : action,
      onsuccess : ReadSuccess,
      onfailed : ReadFailed,
  }
}

// UPDATE
export function UpdatePropsCancelReasign(self, OnSuccsess, OnFailed) {
  return {
    data : {
      Alias : self.requestParams.Alias,
      AuthorizationToken : self.props.UserReducer.token,
    },    
    self: self,
    onsuccess: OnSuccsess,
    onfailed : OnFailed,
  }
}

export function UpdatePropsCancelBooking(self, OnSuccsess, OnFailed) {
  return {
    data : {
      AuthorizationToken : self.props.self.props.UserReducer.token,
    },
    self: self,
    onsuccess: OnSuccsess,
    onfailed : OnFailed,
  }
}

export function UpdatePropsReschedule(self, onUpdateSuccess, onUpdateFailed) {
  return {
    data : {
      Alias       : self.state.SelectedItemReschedule.Alias,
      StartDate   : self.requestParams.startDate_UTC,
      FinishDate  : self.requestParams.endDate_UTC,
      Site        : self.state.SelectedItemReschedule.Site.Alias,
      Location    : self.state.SelectedItemReschedule.Location.Alias,
      Description : '',
      AuthorizationToken : self.props.self.props.UserReducer.token,
    },
    self: self,
    onsuccess: onUpdateSuccess,
    onfailed : onUpdateFailed,
  }
}

export function UpdatePropsMoveAsset(self, onUpdateSuccess, onUpdateFailed) {
  return {
    data : {
      AssetAlias  : self.state.SelectedItem.Alias,
      Site        : self.RegisterParams.Site,
      Location    : self.RegisterParams.Location,
      DueDate     : self.RegisterParams.DueDate,
      AuthorizationToken : self.props.UserReducer.token,
    },
    self: self,
    onUpdateSuccess: onUpdateSuccess,
    onUpdateFailed : onUpdateFailed,
  }
}


export function ReadTrackingProps(action, self, OnReadTrackingSuccess, OnReadTrackingFailed){
  return {
    data: {
      query: self.props.SelectedItem.Alias,
      AuthorizationToken: self.props.UserReducer.token,
    },
    self : self,
    action : action,
    onsuccess : self.OnReadTrackingSuccess,
    onfailed : self.OnReadTrackingFailed,
  }
}
export function ReadMaintenanceByAssetProp(action, self, OnReadMaintenanceSuccess, OnReadMaintenanceFailed){
  return {
    data: {
      query: self.props.SelectedItem.Alias,
      AuthorizationToken: self.props.UserReducer.token,
    },
    self : self,
    action : action,
    onsuccess : self.OnReadMaintenanceSuccess,
    onfailed : self.OnReadMaintenanceFailed,
  }
}
export function ReadCommentsProps(action, self, onReadSuccess, onReadFailed) {
  return {
    data: {
       query :  self.state.SelectedItem.Alias,
       AuthorizationToken : self.props.UserReducer.token,
    },
    action : action,
    self: self,
    onsuccess: onReadSuccess,
    onfailed : onReadFailed,
  }
}
export function RegisterProps(onRegisterSuccess, onRegisterFailed, self){
  return {
    data : {
      Parent  : self.state.SelectedItem.Alias,
      Content : self.state.Register.Comment,
      AuthorizationToken : self.props.UserReducer.token,
    },
    self: self,
    onsuccess: onRegisterSuccess,
    onfailed : onRegisterFailed,
  }
}
export function ReadPropsSummary(action, self, onReadSummarySuccess, onReadSummaryFailed) {
  return{
    data:{
      AuthorizationToken : self.props.UserReducer.token,
    },
    action    : action,
    self      : self,
    onsuccess : onReadSummarySuccess,
    onfailed  : onReadSummaryFailed,
  }
}
export function ExtendProps(self, onExtendSuccess, onExtendFailed) {
  return{
    data:{
      id                 : self.state.assetAlias,
      dueDate_UTC        : self.state.dueDate_UTC,
      AuthorizationToken : self.props.UserReducer.token,
    },    
    self      : self,
    onsuccess : onExtendSuccess,
    onfailed  : onExtendFailed,
  }
}


// WEBPACK FOOTER //
// ./src/App/home/helper/request.props.js